export type OperatingSystem = 'macos' | 'windows' | 'linux' | 'unknown';

export function useOperatingSystem(): OperatingSystem {
  const userAgent = window.navigator.userAgent.toLowerCase();

  if (userAgent.includes('mac')) {
    return 'macos';
  } else if (userAgent.includes('win')) {
    return 'windows';
  } else if (userAgent.includes('linux')) {
    return 'linux';
  } else {
    return 'unknown';
  }
}
